import { Grid, Popup, SafeArea } from 'antd-mobile'
import classNames from 'classnames'
import { isEmpty } from 'lodash-es'
import React, { useContext } from 'react'

import { storeWithContext } from '@/store'
import './index.less'

const HPopup: React.FC<any> = ({
  children,
  className,
  title,
  renderHeader,
  hasCancel = true,
  hasOk = true,
  cancelText = '取消',
  okText = '确认',
  ...props
}: any) => {
  const { deviceIsPortrait, deviceOrientation } = useContext(storeWithContext)

  const position = deviceIsPortrait ? 'bottom' : 'right'

  return (
    <Popup
      className={classNames(
        'h-popup',
        `h-popup-${deviceOrientation}-${position}`,
        `h-popup-${props.size || ''}`,
        className
      )}
      round={deviceIsPortrait}
      {...props}
      bodyStyle={props.bodyStyle}
      position={position}
    >
      {props.position === 'top' && children}
      {renderHeader ? (
        renderHeader()
      ) : (
        <div className='h-popup-header'>
          <div className='h-popup-header-lt'>
            {hasCancel && (
              <div
                className='h-popup-header-link'
                onClick={() => (props.onCancel || props.onClose)?.()}
              >
                {cancelText}
              </div>
            )}
          </div>
          <div className='h-popup-header-md'>
            <div className='h-popup-header-title'>{title || '请选择'}</div>
          </div>
          <div className='h-popup-header-gt'>
            {hasOk && (
              <div className='h-popup-header-link primary' onClick={() => props.onOk?.()}>
                {okText}
              </div>
            )}
          </div>
        </div>
      )}
      {isEmpty(props.columnsHeader) ? null : (
        <Grid columns={props.columnsHeader.length} style={{ padding: 10 }}>
          {props.columnsHeader?.map?.((item: any) => (
            <Grid.Item key={item} className=''>
              <center>{item}</center>
            </Grid.Item>
          ))}
        </Grid>
      )}
      {props.position !== 'top' && children}
      {deviceIsPortrait && <SafeArea position='bottom' />}
    </Popup>
  )
}

export default HPopup
